module.exports = function() {
  return new Worker(__webpack_public_path__ + "7ceaf1b46c919f6a25d1.worker.js");
};